"use client";
import {
  SelectItemCheckedContext
} from "../__chunks/AEGCXJZV.js";
import "../__chunks/JMU4N4M5.js";
import "../__chunks/A62MDFCW.js";
import "../__chunks/LVDQFHCH.js";
import "../__chunks/AVVXDJMZ.js";
import {
  useCheckboxCheck
} from "../__chunks/HOITXJDS.js";
import "../__chunks/EYKMH5G5.js";
import "../__chunks/SMPCIMZM.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/GWSL6KNJ.js";
import "../__chunks/KPHZR4MB.js";
import "../__chunks/YXGXYGQX.js";

// src/select/select-item-check.tsx
import { useContext } from "react";
var TagName = "span";
var useSelectItemCheck = createHook(
  function useSelectItemCheck2({ store, checked, ...props }) {
    const context = useContext(SelectItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck({ ...props, checked });
    return props;
  }
);
var SelectItemCheck = forwardRef(function SelectItemCheck2(props) {
  const htmlProps = useSelectItemCheck(props);
  return createElement(TagName, htmlProps);
});
export {
  SelectItemCheck,
  useSelectItemCheck
};
